<script setup>
import { computed } from 'vue'

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
})

const xLink = computed(() => `#icon-${props.name}`)
</script>

<template>
    <svg
        v-bind="$attrs"
        class="icon"
    >
        <use :xlink:href="xLink" />
    </svg>
</template>
